import _ from 'lodash';

import parseJwt from '@/helper/parseJWT';

const getUserVariables = _.memoize((accessToken) => {
  let userIdFromToken = '';
  try {
    if (accessToken) {
      userIdFromToken = parseJwt(accessToken as string).userId;
    }
  } catch (e) {
    console.error('Error parsing userId from token', e);
  }
  return userIdFromToken;
});

export default getUserVariables;
